import { Component, Input, ViewChild, Output, EventEmitter, OnChanges } from '@angular/core';
import { MaskedTextBoxComponent } from '@progress/kendo-angular-inputs';

import { BaseUIEditableComponent } from './base-ui-editable.component';

@Component({
    selector: 'MaskedTextBox',
    template: `
        <kendo-maskedtextbox  [hidden]="!isVisible"
        [readonly]="shouldMakeReadOnly"  [disabled]="shouldMakeReadOnly" [mask]="InputMask" [(ngModel)]="value" #maskedTextBox (focus)="handleFocus()" (blur)="handleBlur()"></kendo-maskedtextbox>
    `
})

export class StarMaskedTextBoxComponent extends BaseUIEditableComponent implements OnChanges {

    @Input() value = '';
    @Input() InputMask = '';
    @Input() MaxLength;
    @Input() ID: string;
    @ViewChild('maskedTextBox', {static: true}) maskedTextBox: MaskedTextBoxComponent;
    isVisible = true;
    @Output() ValueChange: EventEmitter<any> = new EventEmitter();
    shouldMakeReadOnly: boolean;
    componentType = 'MaskedTextBox';
    oldValue = '';

    ngOnChanges() {
        this.determineClassNameForDOM();
    }

    set Value(arg) {
        this.value = arg + '';
        this.oldValue = this.value;
    }

    get Value() {
        const testVal = this.maskedTextBox.input.nativeElement.value;
        if (!this.value && testVal) {
            return '';
        } else if (this.containsAllSpecialChar()) {
            return '';
        }
        if (!this.value || this.value == 'null' || this.value == 'undefined') {
            return null;
        }
        return this.value.trim();
    }

    containsAllSpecialChar() {
        if (!this.value) {
            return false;
        }
        let maskedChar = '';
        if (this.InputMask.indexOf(':') >= 0) {
            maskedChar = ':';
        }
        const value = this.value.trim();
        return value[0] == maskedChar;
    }

    ngAfterContentInit() {
        this.domEl = this.maskedTextBox.input;
        // this.maskedTextBox.input.nativeElement.style["border"] ="none";
        this.maskedTextBox.input.nativeElement.style['box-shadow'] = 'none';
        this.maskedTextBox.input.nativeElement.className = 'FieldLabel';

        this.maskedTextBox.prompt = '';
        this.determineClassNameForDOM();
    }

    setTabIndexValue() {
        if (this.TabIndexVal) {
            this.maskedTextBox.input.nativeElement.tabIndex = this.TabIndexVal;
        }
    }

    setAuditRelatedFields(className, audit) {
        if (audit) {
            this.title = audit.AudtMessage;
            this.className = className;
            this.readOnly = 'true';
            if (this.domEl) {
                this.appendAClass(className);
                this.domEl.nativeElement.title = this.title;
            }
        }
        if (this.domEl) {
            this.domEl.nativeElement.disabled = true;
            this.domEl.nativeElement.readOnly = true;
        }
        this.readOnly = 'true';
    }

    appendAClass(className: string = '') {
        if (!className) {
            className = this.className;
        }
        let classesOfInputBox: string = this.maskedTextBox.input.nativeElement.className;
        classesOfInputBox = classesOfInputBox.replace('FieldContent', '');
        classesOfInputBox = classesOfInputBox.replace('DisplayField', '');
        classesOfInputBox = classesOfInputBox.replace('EditableMandatoryField', '');
        classesOfInputBox = classesOfInputBox.replace('EditableField', '');
        this.maskedTextBox.input.nativeElement.className = classesOfInputBox + ' ' + className;
    }

    determineClassNameForDOM() {
        this.setTabIndexValue();
        if ((this.enabled && this.enabled.toLowerCase() == 'false') || (this.readOnly && (this.readOnly.toLowerCase() == 'true'))) {
            // disbale the control
            // set disabledDropDown class
            this.shouldMakeReadOnly = true;
            this.maskedTextBox.input.nativeElement.disabled = true;
            this.maskedTextBox.input.nativeElement.readOnly = true;
        } else {
            this.shouldMakeReadOnly = false;
            this.maskedTextBox.input.nativeElement.disabled = false;
            this.maskedTextBox.input.nativeElement.readOnly = false;
        }

        if (this.readOnly && this.readOnly.toLowerCase() == 'true') {
            this.maskedTextBox.input.nativeElement.className = 'DisplayField';
            // this.maskedTextBox.input.nativeElement.style["pointer-events"] = "none";
        } else if (!this.readOnly || this.readOnly.toLowerCase() == 'false') {
            if (this.Mandatory) {
                this.maskedTextBox.input.nativeElement.className = 'EditableMandatoryField';
            } else {
                this.maskedTextBox.input.nativeElement.className = 'EditableField';
            }
            // this.maskedTextBox.input.nativeElement.style["pointer-events"] = "";
        }

        if (this.width) {
            if (this.width.indexOf('%') > 0 || this.width.toLowerCase().indexOf('px') > 0) {
                this.maskedTextBox.input.nativeElement.style['width'] = this.width;
            } else {
                this.maskedTextBox.input.nativeElement.style['width'] = this.width + 'px';
            }
        }
        this.maskedTextBox.input.nativeElement.style['margin-right'] = '4px';
        this.isVisible = this.Visible;
    }

    handleFocus() {
        if (this.ID) {
            this.maskedTextBox.input.nativeElement.autocomplete = 'invalid';
        }
    }

    handleBlur() {
        if (!this.oldValue && !this.Value) {
            return;
        }
        if ( (!this.oldValue && this.Value) || (this.oldValue != this.Value)) {
            this.oldValue = this.Value;
            this.ValueChange.emit(null);
        }
    }

    Focus() {
        this.focus();
    }

    focus() {
      window.setTimeout(() => this.maskedTextBox.input.nativeElement.focus(), 500);
    }
}
